export default "__VITE_ASSET__BCCAf4SA__"